import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Button from 'components/inputs/Button';
import * as _ from 'lodash';
import { useTranslation } from 'react-i18next';

const DeleteModal = (props) => {
  const { title = '', onClose = _.noop(), onRemove = _.noop() } = props;
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className="delete-modal-main_page">
        <div className="delete-modal--inner">
          <div className="delete-modal---block_title">
            <div className="inner--block_title">
              <div className="title">
                {t('button.remove')} {title}
              </div>
              <p className="sub-title">
                {t('header.deleteHeader')} {_.toLower(title)}?
              </p>
            </div>
          </div>
          <div className="delete-modal-input-box__block">
            <Row>
              <Col lg={6}>
                <Button className="delete-model--btn cancel--btn" onClick={onClose}>
                  {t('button.cancel')}
                </Button>
              </Col>
              <Col lg={6}>
                <Button className="delete-model--btn  remove--btn" onClick={onRemove}>
                  {t('button.remove')}
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
DeleteModal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
  onRemove: PropTypes.func,
};
export default DeleteModal;
